import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';

import Appearance from 'styles/Appearance.js';
import Button from 'views/Button.js';
import ListField from 'views/ListField.js';
import Utils from 'files/Utils.js';

const DatePickerField = ({ appendComponent, format, future, icon, inset, insetLabel, onChange, placeholder, returnDefault, style, utils, value }) => {

    const [day, setDay] = useState(null);
    const [days, setDays] = useState([]);
    const [hover, setHover] = useState(false);
    const [month, setMonth] = useState(null);
    const [months, setMonths] = useState([]);
    const [year, setYear] = useState(null);
    const [years, setYears] = useState([]);

    const onParseDate = () => {
        if(!day || !month || !year) {
            return;
        }
        let next = moment(`${year.id}-${month.id}-${day.id}`);
        if(!next.isValid()) {
            if(typeof(onChange) === 'function') {
                onChange(null);
            }
            return;
        }
        if(typeof(onChange) === 'function') {
            onChange(next);
        }
    }

    const onSetDays = () => {
        if(!month) {
            return;
        }

        // setup days based on month's day count
        let date = moment(`2021-${month.id}-01`, 'YYYY-MMMM-DD');
        let days = date.daysInMonth();
        setDays([ ...Array(days || 1) ].map((_, index) => {
            let val = moment(date).startOf('month').add(index, 'days');
            return {
                id: val.format('DD'),
                title: val.format('Do')
            }
        }));

        // remove selected day if it is greater than the total days in the month
        // this is needed for months with 28, 29, or 30 days
        if(day && day > days) {
            setDay(null);
        }
    }

    const getFieldStyle = () => {
        return {
            width: '100%',
            color: Appearance.colors.text(),
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none',
            borderBottom: 'none'
        }
    }

    const setupTarget = () => {

        // setup list items
        setMonths([ ...Array(12) ].map((_, index) => {
            let val = moment().startOf('year').add(index, 'months');
            return {
                id: val.format('MM'),
                title: val.format('MMMM')
            }
        }));
        setYears([ ...Array(100) ].map((_, index) => {
            let val = future ? moment().add(index, 'years') : moment().subtract(index, 'years');
            return {
                id: val.format('YYYY'),
                title: val.format('YYYY')
            }
        }));
        setDays([ ...Array(31) ].map((_, index) => {
            let val = moment().startOf('year').startOf('month').add(index, 'days');
            return {
                id: val.format('DD'),
                title: val.format('Do')
            }
        }));

        // setup default day, month, and year
        let target = value ? moment(value) : moment();
        setDay({
            id: target.format('DD'),
            title: target.format('Do')
        });
        setMonth({
            id: target.format('MM'),
            title: target.format('MMMM')
        });
        setYear({
            id: target.format('YYYY'),
            title: target.format('YYYY')
        });
    }

    useEffect(() => {
        onSetDays();
    }, [month]);

    useEffect(() => {
        onParseDate();
    }, [day, month, year]);

    useEffect(() => {
        setupTarget();
    }, []);

    return (
        <div style={{
            width: '100%',
            ...style,
            height: 'auto'
        }}>
            <div
            className={'row p-0 m-0'}
            style={{
                width: '100%'
            }}>
                <div className={'col-5 p-0 pl-0 pr-2 animate-500ms'}>
                    <ListField
                    insetLabel={inset !== false ? 'Month' : null}
                    items={months}
                    onChange={item => setMonth(item)}
                    value={month} />
                </div>
                <div className={'col-3 p-0 animate-500ms'}>
                    <ListField
                    insetLabel={inset !== false ? 'Day' : null}
                    items={days}
                    onChange={item => setDay(item)}
                    value={day} />
                </div>
                <div className={'col-4 p-0 pl-2 pr-0'}>
                    <ListField
                    insetLabel={inset !== false ? 'Year' : null}
                    items={years}
                    onChange={item => setYear(item)}
                    value={year} />
                    {appendComponent}
                </div>
            </div>
        </div>
    )
}
export default DatePickerField;
